// src/services/userService.ts
import api from "../lib/api.ts";

/**
 * Checks whether the specified user is registered as a buyer or seller.
 * Returns an object with `isRegistered: boolean`.
 */
export const checkUserRegistered = async (userId: number) => {
  const response = await api.get(`/users/is-registered/${userId}`);
  return response.data.isRegistered;
};
